<template>
	<v-dialog
		v-model="show"
		v-if="show"
		@keydown.esc="show = false"
		max-width="500"
	>
		<v-card>
			<v-card-title class="success body-2 white--text">
				Selected articles' stats will be refetched
			</v-card-title>
			<template v-if="countSelectedArticles > 1">
				<v-card-text style="max-height: 400px; overflow-y: scroll;">
					<h4 class="mb-2">Articles' stats to be refetched:</h4>
					<ul>
						<li
							v-for="article in articles"
							:key="article.id"
						>
							"{{ article.titleText }}"
						</li>
					</ul>
				</v-card-text>
				<v-divider/>
			</template>
			<v-card-actions>
				<v-spacer />
				<v-btn
					color="success"
					flat
					@click="refetchArticlesStats()"
				>
					OK
				</v-btn>
				<v-btn
					flat
					@click="show = false"
				>
					Cancel
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { sync } from 'vuex-pathify';
import { Articles } from '@/models/Article';

export default {
	computed: {
		show: sync('articlesRefetchStatsDialog/show'),
		articles: sync('articlesRefetchStatsDialog/articles'),
		currentReport() {
			return this.$store.get('reports/currentReport');
		},
		countSelectedArticles() {
			return (!this.articles ? 0 : this.articles.length);
		},
	},
	methods: {
		refetchArticlesStats() {
			var articles = new Articles();
			articles.add(this.articles);
			articles.refetchArticlesStats(this.currentReport);

			this.show = false;
		},
	}
};
</script>

<style></style>
